// extracted by mini-css-extract-plugin
export var root = "_zt-0";
export var scroll = "_zt-1";
export var thumb = "_zt-3";
export var track = "_zt-2";